import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;
const reqUrl = `${BASE_URL}/chatbot/postback`;

export const sendLinePostback = async (payload) => {
  try {
    const response = await axios.post(reqUrl, payload);

    return response.data;
  } catch (err) {
    throw err;
  }
};

const calendarCenterUrl = `${BASE_URL}/calendar/postback`;
export const getCalendarPostback = async (payload) => {
  try {
    const response = await axios.post(calendarCenterUrl, payload, {
      responseType: 'blob',
    });

    return response.data;
  } catch (err) {
    throw err;
  }
};

const lineReurlTagUrl = `${BASE_URL}/hotai_tag/reurl`;
export const sendLineReurlTag = async (payload, idToken) => {
  try {
    const response = await axios.post(lineReurlTagUrl, payload, {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    });

    return response.data;
  } catch (err) {
    throw err;
  }
};

const ToyotaPremiumHotaiGo = `${BASE_URL}/hotaigo/tp_hotai_go`;
export const sendToyotaPremiumHotaiGo = async (idToken) => {
  try {
    const response = await axios.post(
      ToyotaPremiumHotaiGo,
      {},
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      }
    );

    return response.data;
  } catch (err) {
    throw err;
  }
};

const ToyotaPremiumMemberService = `${BASE_URL}/service/member_service`;
export const sendToyotaPremiumMemberService = async (idToken) => {
  try {
    const response = await axios.post(
      ToyotaPremiumMemberService,
      {},
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      }
    );

    return response.data;
  } catch (err) {
    throw err;
  }
};

const ToyotaPremiumSecretary = `${BASE_URL}/service/car_secretary`;
export const sendToyotaPremiumSecretary = async (idToken) => {
  try {
    const response = await axios.post(
      ToyotaPremiumSecretary,
      {},
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      }
    );

    return response.data;
  } catch (err) {
    throw err;
  }
};

const ToyotaPremiumWallpaperUpload = `${BASE_URL}/custom_wallpaper/upload`;
export const uploadToyotaPremiumWallpaper = async (idToken, payload) => {
  try {
    const response = await axios.post(ToyotaPremiumWallpaperUpload, payload, {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    });

    return response.data;
  } catch (err) {
    throw err;
  }
};

const ToyotaPremiumWallpaperSetting = `${BASE_URL}/custom_wallpaper/wallpaper_setting`;
export const toyotaPremiumWallpaperSetting = async () => {
  try {
    const response = await axios.post(ToyotaPremiumWallpaperSetting, {});

    return response.data;
  } catch (err) {
    throw err;
  }
};
